import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];
const AppLogout = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  const user = localStorage.getItem("userDetail"); // Get user type
  const navigate = useNavigate();
  const [isLoggedOut, setIsLoggedOut] = useState(false); // Track if user is logged out
  const timerRef = useRef(null); // Store the timer reference

  // Function to reset the inactivity timer
  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  // Function to start the logout timer
  const handleLogoutTimer = () => {
    resetTimer(); // Ensure no duplicate timers
    timerRef.current = setTimeout(() => {
      logoutAction("Session expired! Due to inactivity");
    }, 9000000); // 15 minutes (900000ms)
  };

  // Logout function
  const logoutAction = (msg) => {
    if (!isLoggedOut) {
      // Prevent multiple alerts
      setIsLoggedOut(true);
      localStorage.clear();
      // Remove all event listeners
      events.forEach((event) => {
        window.removeEventListener(event, activityListener);
      });
      // alert(msg);
      navigate("/auth-login");
    }
  };

  // Event listener to reset the timer on user activity
  const activityListener = () => {
    if (!isLoggedOut) {
      resetTimer();
      handleLogoutTimer();
    }
  };

  useEffect(() => {
    if (token && user?.role === "admin") {
      events.forEach((event) =>
        window.addEventListener(event, activityListener)
      );
      handleLogoutTimer();
    } else if (!token || user === null) {
      logoutAction("unauthorized access!");
    }

    return () => {
      resetTimer();
      events.forEach((event) =>
        window.removeEventListener(event, activityListener)
      );
    };
  }, [token, user]);

  return children;
};

export default AppLogout;
